import React from 'react';
import Spinner from '@xo-union/tk-component-spinner';
import styles from './index.scss';

interface Props {
  loading?: boolean;
}
const LoadingOverlay: React.FC<Props> = ({ loading = false }) => {
  return (
    <>
      {loading && (
        <div className={styles.formOverlay}>
          <Spinner />
        </div>
      )}
    </>
  );
};

export default LoadingOverlay;
